// Module-level pub/sub used by axios interceptors (non-React) to notify the
// React tree that a "no valid subscription" response was received.
// Lives outside React so it can be imported by axios instance files without
// creating circular deps with context providers.

const SUBSCRIPTION_REQUIRED_MESSAGE =
  "No valid trial or active subscription. Redirecting to payment.";

const listeners = new Set();

export const onSubscriptionRequired = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const emitSubscriptionRequired = () => {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch (_) {
      // ignore listener errors — one bad subscriber shouldn't break others
    }
  });
};

export const isSubscriptionRequiredError = (error) =>
  error?.response?.data?.message === SUBSCRIPTION_REQUIRED_MESSAGE;
